module.exports = __webpack_public_path__ + "img/tutorial3.4bd1d0bf.png";